import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function AddPrintedRemarksModal({
  createTextArea,
  tagAsPrintedTransaction,
  formData,
  setFormData,
  id,
  transactionId,
  submitting,
  showTransaction,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      remarks: formData.remarks,
    };

    tagAsPrintedTransaction(id, args, () => {
      setModal({ isOpen: false });
      showTransaction(transactionId);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      remarks: '',
    });
  }, []);

  let remarksValidation = {
    remarks: 'required',
  };

  const validateForm = useFormValidator(formData, remarksValidation);

  useEffect(() => {
    if (_.get(formData, 'remarks')) {
      remarksValidation = {
        ...formData,
        remarks: 'required|min_3_character',
      };
    }

    validateForm.onSetObjectRules(remarksValidation);
  }, [_.get(formData, 'remarks')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label>Are you sure you want to tag this application as printed?</label>
            <label className="full-label mb-0">
              Remarks: {validateForm.renderMessage('remarks')}
            </label>
            {createTextArea(
              { key: 'remarks' },
              { maxLength: '500', rows: '15' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={submitting}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-cancel"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            disabled={submitting}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary ml-3"
          >
            <span className="font-weight-bold">
              {submitting ? <i className="fa fa-spin fa-spinner" /> : `Confirm`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AddPrintedRemarksModal.propTypes = {
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  tagAsPrintedTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  transactionId: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  submitting: api.loading.indexOf(c.TAG_AS_PRINTED_TRANSACTION) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddPrintedRemarksModal);
